import React, { PureComponent } from 'react';

import { Container, filterProps, focuseable } from '@lglp/components';
import { flatten, is, prop, when } from 'ramda';
import { Link as InnerLink } from 'react-router-dom';

import formatLink from './formatLink';
import OuterLink from './OutboundLink';

const processClassName = when(is(Array), (arr) =>
  flatten(arr).filter(Boolean).join(' ')
);

export class LinkComponent extends PureComponent {
  static displayName = 'LinkComponent';

  static handledProps = [
    'eventLabel',
    'linkType',
    'url',
    'uid',
    'id',
    'lang',
    'disabled',
    'category',
    'reset',
    'innerRef',
  ];

  static defaultProps = {
    download: undefined,
    disabled: false,
  };

  render() {
    const { innerRef, lang, onClick, children, linkType, disabled, className } =
      this.props;

    let link = formatLink(this.props);
    const eventLabel = prop('eventLabel', link);
    link = filterProps(LinkComponent, link);
    link.className = processClassName([
      linkType || 'link-other',
      'link',
      disabled && 'disabled',
      className,
    ]);

    if (lang) {
      link.hrefLang = lang;
    }

    if (disabled) {
      return (
        <Container
          as="span"
          innerRef={innerRef}
          className={link.className}
          title={link.title}
        >
          {children}
        </Container>
      );
    }

    link.onClick = onClick;

    if (eventLabel) {
      return (
        <OuterLink ref={innerRef} {...link}>
          {children}
        </OuterLink>
      );
    }

    return (
      <InnerLink innerRef={innerRef} {...link}>
        {children}
      </InnerLink>
    );
  }
}

export default focuseable(LinkComponent);
